import { BarcodeOutlined } from "@ant-design/icons";
import { Col, Input, InputRef, Modal, Row, Select, message } from "antd";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ItemsList from "./ItemsList";
import { useMutation, useQuery } from "react-query";
import {
  getCurrentPriceByBarcode,
  getCurrentPriceByCategory,
  getCurrentPrices,
} from "../../../../api/pricesCurrent";
import Title from "../../../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { Search } from "../../../UI/Search/Search";
import ResetButton from "../../../UI/ResetButton/resetbutton";
import { useDispatch } from "react-redux";
import { mainActions } from "../../../../store/main/mainSlice";
import { getCategoryDrpdown } from "../../../../api/category";
import { checkItemQuantityFunctionContext } from "../../MainFour";
import { getIsGridViewLS } from "../../../../utils/main-utils";
import CardsList from "./CardsList";

type PropsType = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const StockModal = ({ isOpen, setIsOpen }: PropsType) => {
  const [items, setItems] = useState<any>();
  const [selectedItems, setSelectedItems] = useState([]);
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState<any>();
  const [selectedCategory, setSelectedCategory] = useState<number>();
  const [barcode, setBarcode] = useState<string>("");
  const [t] = useTranslation("common");
  const [page, setPage] = useState(1);
  const [tableKey, setTableKey] = useState("");
  const [visible, setVisible] = useState(false);

  const { mutateAsync: getItemsMutation, isLoading: isItemsLoading } =
    useMutation("items", () =>
      getCurrentPriceByCategory({ q: search, categoryId: selectedCategory, warehouseId: 1 })
    );
  const { mutateAsync: getItemsSearchMutation } = useMutation(
    "items",
    () => getCurrentPrices(search, page * 10 + 10),
    {
      onSuccess: (res) => {
        setItems(res.data.data);
      },
    }
  );
  const barcodeRef = useRef<InputRef>(null);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        barcodeRef.current?.focus();
      }, 0);
    }
  }, [isOpen]);
  useEffect(() => {
    getItemsSearchMutation();
  }, [getItemsSearchMutation, page]);
  const {
    mutateAsync: getItemsBarcodeMutation,
    isLoading: isItemsBarcodeLoading,
  } = useMutation("items", () => getCurrentPriceByBarcode(barcode));
  const { isLoading: isCategoriesLoading, refetch: refetchCategories } =
    useQuery("items", getCategoryDrpdown, {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        const activeData = res.data.filter(
          (category: any) => category.isActive
        );
        setCategories(
          activeData.map((category: any) => {
            return { label: category.name, value: category.id };
          })
        );
        setSelectedCategory(activeData[0].id);
      },
    });

  useEffect(() => {
    if (selectedCategory) {
      getItemsMutation().then((res) => {
        setItems(res.data);
      });
    } else {
      refetchCategories();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (visible) {
      getItemsMutation().then((res) => {
        setItems(res.data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    setVisible(isOpen);
  }, [isOpen]);

  return (
    <>
      <Modal
        maskClosable={false}
        closable={false}
        centered
        open={isOpen}
        okText={`${t("confirm")}`}
        onOk={() => {
          selectedItems.map((item: any) => {
            dispatch(
              mainActions.addItem({
                name: item.item.name,
                itemId: item.item.id,
                barcode: item.item.barcode,
                cost: item.averageCost,
                price: item.lastPrice,
                totalPrice: item.lastPrice,
                isTaxable: item?.item.isTaxable,
                extraCharge: 0,
                tax: item?.item?.tax,
                discount: null,
                notes: "",
                qty: 1,
                qtyInStock: item?.currentQuantity,
                specifications: [],
              })
            )
            return null;
          });
          setSelectedItems([]);
          setSearch("");
          setIsOpen(false);
          setSelectedCategory(undefined);
          document.body.classList.remove("body-scroll-lock");
        }}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
        }}
        onCancel={() => {
          setIsOpen(false);
          setSearch("");
          setSelectedItems([]);
          setSelectedCategory(undefined);
          document.body.classList.remove("body-scroll-lock");
        }}
        width={1200}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        cancelText={t('cancel')}
        destroyOnClose
      >
        <Row gutter={[10, 10]}>
          <Col span={23}>
            <Title title={`${t("items-in-stock")}`} />
          </Col>
          <Col span={4}>
            <Select
              size="large"
              style={{ width: "100%" }}
              placeholder={`${t("select-category")}`}
              options={categories}
              loading={isCategoriesLoading}
              value={selectedCategory}

              onChange={(e) => {
                setSelectedCategory(e);
              }}
            />
          </Col>
          <Col span={6}>
            <Input
              style={{ height: " 40px" }}
              type="number"
              ref={barcodeRef}
              className="btn-shadow"
              placeholder={`${t("barcode")}`}
              value={barcode}
              onChange={(e) => {
                setBarcode(e.target.value);
              }}
              onPressEnter={() => {
                barcode &&
                  getItemsBarcodeMutation().then((res) => {
                    setItems([res?.data]);
                    setBarcode("");
                  });
              }}
              suffix={
                <BarcodeOutlined
                  style={{ fontSize: "20px", color: "#8C8C8C" }}
                  onClick={() => {
                    barcode &&
                      getItemsBarcodeMutation().then((res) => {
                        setItems([res?.data]);
                        setBarcode("");
                      });
                  }}
                />
              }
            />
          </Col>
          <Col span={6}>
            <Search
              onEnter={() => {
                getItemsSearchMutation();
              }}
              value={search}
              onChange={(e: any) => {
                setSearch(e.target.value);
              }}
            />
          </Col>

          <Col offset={6}>
            <ResetButton
              onClick={() => {
                setBarcode("");
                setSearch("");
                setTableKey((tableKey) => tableKey + 1);
                setSelectedCategory(undefined)
                !search &&
                  getItemsMutation().then((res) => {
                    setItems(res.data);
                  });
              }}
            />
          </Col>
          <Col span={24} style={{ height: items?.length > 5 && getIsGridViewLS() ? '450px' : '', overflow: 'scroll' }}>
            {getIsGridViewLS() ? <CardsList
              items={items}
              isLoading={isItemsLoading || isItemsBarcodeLoading}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
              page={page}
              setPage={setPage}
              getItemsSearchMutation={getItemsSearchMutation}
              tableKey={tableKey} /> : <ItemsList
              items={items}
              isLoading={isItemsLoading || isItemsBarcodeLoading}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
              page={page}
              setPage={setPage}
              getItemsSearchMutation={getItemsSearchMutation}
              tableKey={tableKey}
            />}
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default StockModal;
